import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=6b985e64&"
import script from "./loginView.vue?vue&type=script&lang=js&"
export * from "./loginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports